import { apiHelper } from '../helpers/apiHelper'

const API_URL = '/api/webhooks/log'

export default {
  ...apiHelper(API_URL),
}
